import { ChangeEvent } from 'react';
import { CircularProgress, Pagination } from '@mui/material';
import { Titulo } from '../../../interfaces/entities/Titulo';
import TabelaTitulos from './TabelaTitulos';
import { sxPagination } from './sxProps';
import { sxPaginationContrast } from '../../../assets/styles/CommonSxProps';
import { scrollTo } from '../../../utils/ScrollUtil';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';

interface AbaHistoricoProps {
  titulos: Titulo[];
  loading: boolean;
  page: number;
  onPageChange: (event: ChangeEvent<unknown>, newPage: number) => void;
  onVisualizarClicked: (id: string) => void;
  paginationLength: number;
}

function AbaHistorico({
  titulos,
  loading,
  page,
  onPageChange,
  onVisualizarClicked,
  paginationLength
}: AbaHistoricoProps) {
  const accessibility = useAccessibility();

  const handlePageChange = (event: ChangeEvent<unknown>, newPage: number) => {
    onPageChange(event, newPage);
    scrollTo('scroll-ref');
  };

  const paginatedTitulos = titulos.slice(
    (page - 1) * paginationLength,
    page * paginationLength
  );

  const totalItems = titulos.length;
  const isEmpty = !titulos.length;

  if (loading) {
    return (
      <div className='loading-holder'>
        <CircularProgress />
      </div>
    );
  }

  if (isEmpty) {
    return null;
  }

  return (
    <div id='scroll-ref'>
      <TabelaTitulos
        data={paginatedTitulos}
        onVisualizarClicked={onVisualizarClicked}
        buttonLabel='Ver fatura'
        columnLabel='Título'
      />

      {totalItems > paginationLength && (
        <Pagination
          className='pagination-holder'
          count={Math.ceil(totalItems / paginationLength)}
          sx={accessibility.contrastMode ? sxPaginationContrast : sxPagination}
          hideNextButton
          hidePrevButton
          color='primary'
          page={page}
          onChange={handlePageChange}
        />
      )}
    </div>
  );
}

export default AbaHistorico;
